import { ActionType, createAsyncAction } from 'typesafe-actions'
import { Failure, Request, Success } from './types'
import { CustomButtonState } from '../../types'

export const fetchCustomButtonsByCompanyAction = createAsyncAction(
  '@custom-button/FETCH_CUSTOM_BUTTONS_BY_COMPANY_REQUEST',
  '@custom-button/FETCH_CUSTOM_BUTTONS_BY_COMPANY_SUCCESS',
  '@custom-button/FETCH_CUSTOM_BUTTONS_BY_COMPANY_FAILURE'
)<Request, Success, Failure>()

const request = (state: CustomButtonState): CustomButtonState => ({
  ...state,
  isLoadingFetchCustomButtonsByCompany: true
})

const success = (
  state: CustomButtonState,
  action: ActionType<typeof fetchCustomButtonsByCompanyAction.success>
): CustomButtonState => {
  return {
    ...state,
    customButtons: action.payload?.customButtons || [],
    isSuccessFetchCustomButtonsByCompany: true,
    isLoadingFetchCustomButtonsByCompany: false
  }
}

const failure = (
  state: CustomButtonState,
  { payload }: ReturnType<typeof fetchCustomButtonsByCompanyAction.failure>
): CustomButtonState => {
  return {
    ...state,
    isLoadingFetchCustomButtonsByCompany: false,
    isErrorFetchCustomButtonsByCompany: true
  }
}

export const fetchCustomButtonsByCompanyHandle = {
  asyncAction: fetchCustomButtonsByCompanyAction,
  request,
  success,
  failure
}
